export function reloadNpOffices($select, city, company, valueOrCallback = null, officeType = null) {
    if ($select.length) {
        $select.prop('disabled', true);
        $select.children().remove();

        $.get('delivery/getNPCityOfficesAjax', { city, company, type: officeType }, null, 'json')
            .done(response => {
                if (response.success) {
                    $.each(response.data, function (value, text) {
                        const $new = $('<option>', { value, text });
                        $select.append($new);
                    });
                    $select.prop('disabled', false);
                    if (valueOrCallback) {
                        if ($.isFunction(valueOrCallback)) {
                            valueOrCallback();
                        } else {
                            $select.val(valueOrCallback);
                            $select.trigger('change').trigger('chosen:updated');
                        }
                    } else {
                        const $first = $($select.children()[0]);
                        $first.attr('selected', 'selected');
                        $select.trigger('change').trigger('chosen:updated');
                    }
                }
            });
    }
}


// WEBPACK FOOTER //
// ./modules/blocks/delivery_data_form/utils.js